module.exports = __webpack_public_path__ + "media/images/homepage/Oval-a4a05add024c5081e5a8565faab8dd15.png";